/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoListModel } from '../../models/organization-logo-list-model';

export interface ConsumerFhirIdLogoGet$Params {
  fhirId: string;
}

export function consumerFhirIdLogoGet(http: HttpClient, rootUrl: string, params: ConsumerFhirIdLogoGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationLogoListModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerFhirIdLogoGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationLogoListModel>>;
    })
  );
}

consumerFhirIdLogoGet.PATH = '/Consumer/{fhirId}/Logo';
